
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/open-adr",
      function () {
        return require("private-next-pages/evcharging/open-adr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/open-adr"])
      });
    }
  